module.exports = __webpack_public_path__ + "img/img10.7aa29c80.svg";